/**
 * Injects the theme "Custom button icon" into Kickflip's #kickflip-customize-button.
 * Kickflip owns the element and its content; we only prepend the icon rendered
 * by snippets/button-custom-icon.liquid.
 */
(function () {
  const BUTTON_ID = 'kickflip-customize-button';
  const ICON_TEMPLATE_ID = 'kickflip-custom-button-icon';
  const WRAPPER_CLASS = 'icon-with-text';

  function getIconFragment() {
    const tpl = document.getElementById(ICON_TEMPLATE_ID);
    if (!tpl || !tpl.content) return null;
    return tpl.content.cloneNode(true);
  }

  function enhanceButton(button) {
    if (!button || button.classList.contains(WRAPPER_CLASS)) return;

    const iconFrag = getIconFragment();
    if (!iconFrag) return;

    button.classList.add(WRAPPER_CLASS);
    button.prepend(iconFrag);
  }

  function tryEnhance() {
    enhanceButton(document.getElementById(BUTTON_ID));
  }

  function observe() {
    tryEnhance();

    const observer = new MutationObserver(tryEnhance);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
